<template>
  <div class="container">
    <el-row :gutter="10" v-if="filterWrapperShow">
     <el-col  :md="18" :lg="16" :xl="12">
       <filter-wrapper
         :filter-item="{searchBox: true, canteen: true, eatery: true, date: false, dateRange: true, machine: true }">
       </filter-wrapper>
     </el-col>
      <el-col :span="2">
        <div class="btn-wrapper">
          <el-button type="primary" @click="getBatchList">查询</el-button>
        </div>
      </el-col>
    </el-row>
    <batch-table
      :batch-list="batchList"
      :canteen="canteen"
      :eatery="eatery"
    ></batch-table>
  </div>
</template>
<script>
import batchTable from './batchTable';
import filterWrapper from '_c/filterWrapper';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetBatchList} from '@/api';
import {errorMessage} from '@/lib/msg';

export default {
  name: 'batchList',
  components: {
    batchTable,
    filterWrapper
  },
  data () {
    return {
      checkedStateList: []
    };
  },
  mounted () {
    setTimeout(() => {
      this.getBatchList();
    }, 500);
  },
  methods: {
    ...mapActions(['setMarkImageList', 'setBatchList']),
    ...mapMutations(['emitLoading', 'removeLoading']),
    async getBatchList () {
      this.emitLoading();
      function dateToUnixtimestamp (dateObj, time) {
        return (
          new Date(new Date(dateObj).setHours(0, 0, 0, 0)) / 1000 +
          time * 3600 * 24
        );
      }
      try {
        let res = await apiGetBatchList({
          machine_id: this.listQuery.machine ? this.listQuery.machine.machine_id : 0,
          canteen_id: this.canteen.canteen_id,
          collect_time_range: {
            start_ts: dateToUnixtimestamp(this.dateRange[0], 0),
            end_ts: dateToUnixtimestamp(this.dateRange[1], 1)
          },
          apiKey: this.apiKey
        });
        this.setBatchList(res.batch_list);
        this.removeLoading();
      } catch (e) {
        console.log(e);
        this.removeLoading();
        errorMessage('查询批次信息失败');
      }
    }
  },
  computed: {
    ...mapGetters(['modelList', 'batchList', 'listQuery', 'userinfo']),
    apiKey () {
      return this.userinfo().api_key;
    },
    canteen () {
      let {canteen_id, canteen_name} = this.taskInfo;
      return this.filterWrapperShow ? this.listQuery.canteen : {canteen_id, canteen_name};
    },
    eatery () {
      let {eatery_id, eatery_name} = this.taskInfo;
      return this.filterWrapperShow ? this.listQuery.eatery : {eatery_id, eatery_name};
    },
    dateRange () {
      let ts = this.taskInfo.day_ts;
      ts = [
        new Date(ts * 1000),
        new Date((ts + 24 * 3600) * 1000)
      ];
      return this.filterWrapperShow ? this.listQuery.dateRange : ts;
    },
    taskInfo () {
      return this.$route.params.taskInfo || null;
    },
    filterWrapperShow () {
      return !this.$route.params.hasOwnProperty('taskInfo');
    },
    stateOptions () {
      return [
        {index: 0, state: '未标注'},
        {index: 1, state: '标注中'},
        {index: 2, state: '待审核'},
        {index: 3, state: '审核通过'},
        {index: 4, state: '审核不通过'}
      ];
    }
  },
  watch: {
    canteen: {
      handler () {
        this.getBatchList();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    position: relative;
    .filter {
    }
    .btn-wrapper {
      position: relative;
      top: 5px;
    }
  }
</style>
